import { render, staticRenderFns } from "./WorkHoursTable.vue?vue&type=template&id=0b76c808"
import script from "./WorkHoursTable.vue?vue&type=script&lang=js"
export * from "./WorkHoursTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports